import { getFeatureFlags, useFeatureFlags } from '@/flags'

export function useExperimentalConfiguratorUx(): boolean {
  return useFeatureFlags().experimentalConfiguratorUx
}

export function switchConfiguratorUx(enabled: boolean): void {
  getFeatureFlags().set('experimentalConfiguratorUx', enabled)
  window.location.reload()
}
